import React, { useEffect, useState } from "react";
import { Badge, OverlayTrigger, Popover } from "react-bootstrap";
import { useSelector } from "react-redux";
import ChemicalInfo from "components/chemicalRecipes/ChemicalInfo";
import { USAGE_CONTAINS_THE_FOLLOWING_CHEMICALS } from "configurations/MessageConstants";

const ChemicalBadge = ({ chemical }) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Popover id={`popover-${chemical.chemicalId}`}>
          <ChemicalInfo chemicalId={chemical.chemicalId} />
        </Popover>
      }
    >
      <Badge pill className="chemical-badge">
        <small>{`${chemical.name} ${chemical.quantity} ${chemical.unit}`}</small>
      </Badge>
    </OverlayTrigger>
  );
};

const RecipeSummary = ({ recipeId, editedRecipeUsage }) => {
  const recipes = useSelector((state) => state.recipe.recipes);
  const selectedRecipe = recipes.find((recipe) => recipe.id == recipeId);
  const [usageChemicals, setUsageChemicals] = useState([]);

  useEffect(() => {
    const usage =
      !recipeId || recipeId === editedRecipeUsage?.recipeId
        ? editedRecipeUsage?.chemicals
        : selectedRecipe?.chemicals;
    setUsageChemicals(usage ?? []);
  }, [recipeId, selectedRecipe, editedRecipeUsage]);

  if (!usageChemicals?.length) return null;

  return (
    <div className="mb-3 border rounded p-2">
      <div className="mb-2 small text-muted">
        {USAGE_CONTAINS_THE_FOLLOWING_CHEMICALS}
      </div>
      <div className="d-flex gap-1 flex-row flex-wrap">
        {usageChemicals.map((chemical) => (
          <ChemicalBadge key={chemical.chemicalId} chemical={chemical} />
        ))}
      </div>
    </div>
  );
};

export default RecipeSummary;
